export const getImages = (imageName) => {
    try {
        const image = require(`../../assets/img/${imageName}`);
        return image;
    } catch(err) {
        return 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=';
    }
}

export const LazyImage = ({ src, alt }) => {
    return (
            <img src={src} alt={alt} />
    );
};
export const teamImages = require.context('../../assets/img/team', false, /\.(png|jpe?g|svg)$/);